import { getDynamicData, loadScript, loadScriptOnUserInteraction } from '@avensia/excite';

function configFreshChatGAEvents(googleAnalyticsKey: string) {
  if (typeof window.ga === 'function') {
    window.ga('create', googleAnalyticsKey, 'auto', 'FreshchatEvents');
    window.fcWidget.on('widget:loaded', function () {
      window.fcWidget.on('widget:opened', function () {
        window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'Widget Open');
      });
      window.fcWidget.on('widget:closed', function () {
        window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'Widget Close');
      });
      window.fcWidget.on('message:received', function () {
        window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'Received');
      });
      window.fcWidget.on('message:sent', function () {
        window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'Sent');
      });
      window.fcWidget.on('user:statechange', function (resp: any) {
        if (resp && resp.data && resp.data.userState === 'created') {
          window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'User Create');
        }
        if (resp && resp.data && resp.data.userState === 'loaded') {
          window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'User Loaded');
        }
        if (resp && resp.data && resp.data.userState === 'identified') {
          window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'User Identified');
        }
        if (resp && resp.data && resp.data.userState === 'restored') {
          window.ga('FreshchatEvents.send', 'event', 'Freshchat widget', 'GadgetGod', 'User Restored');
        }
      });
    });
  } else {
    console.log('Google Analytics not loaded');
  }
}

async function loadFreshChat(loadOnInteraction = true) {
  if (window.CookieInformation && !window.CookieInformation.getConsentGivenFor('cookie_cat_functional')) {
    return;
  }

  const scriptSettings = await getDynamicData<NordicNest.Api.ScriptSettingsApiModel>().current();

  if (scriptSettings && scriptSettings.freshchatActive) {
    const customerInfo = await getDynamicData<NordicNest.Api.CustomerApiModel>().current();
    const locale = window.INITIAL_DATA.currentLanguageTwoLetterName;
    const config = scriptSettings.freshchatWidgetSettings
      ? JSON.parse(scriptSettings.freshchatWidgetSettings)
      : undefined;

    window.fcSettings = {
      token: '1acc9ae7-e5be-4362-a86d-9209996681da',
      host: 'https://wchat.freshchat.com',
      tags: scriptSettings.freshchatWidgetTags,
      widgetUuid: scriptSettings.freshchatWidgetUuid,
      config,
      locale,
      email: customerInfo?.email,
      siteId: scriptSettings.freshchatSiteId ?? '',
      faqTags: {
        tags: scriptSettings.freshchatFaqTags,
        filterType: 'category',
      },
      onInit: function () {
        configFreshChatGAEvents(scriptSettings.googleAnalyticsKey);
      },
    };

    if (loadOnInteraction) {
      loadScriptOnUserInteraction('//wchat.freshchat.com/js/widget.js');
    } else {
      loadScript('//wchat.freshchat.com/js/widget.js');
    }
  }
}

export async function useFreshChat() {
  if (!__BROWSER__) {
    return;
  }

  loadFreshChat();
  window.addEventListener('CookieInformationConsentGiven', function () {
    loadFreshChat(false);
  });
}
